<!-- password-input.component.html -->
<div class="password-input-container">
  <input
    [type]="isPasswordVisible ? 'text' : 'password'"
    [(ngModel)]="password"
    name="password"
    (ngModelChange)="emitPassword()"
  />
  <button
    type="button"
    (click)="togglePasswordVisibility()"
    class="toggle-visibility"
  >

  @if(hideController() === 'hidden'){
    <div (click)="onIconClick()">
      <svg class="icon icon__hide">
        {{ isPasswordVisible ? "visibility_off" : "visibility" }}
        <use xlink:href="images/sprites5.svg#icon-eye-blocked"></use>
      </svg>
    </div>

    } @else{
    <div (click)="onIconClick()">
      <svg class="icon icon__hide">
        {{ isPasswordVisible ? "visibility_off" : "visibility" }}
        <use xlink:href="images/sprites5.svg#icon-eye"></use>
      </svg>
    </div>

    }

  </button>
</div>
